<template>
  <div class="task taskLink">
    <button v-on:click="callTask()" v-tooltip="{content: task.info, delay: { show: 400, hide: 100 }, placement: 'bottom'}" type="button" class="w3-buttonTask">
      <transition name="fade" mode="out-in">
        <spinner-loading v-if="taskLoading" class="spinner-loading" :line-size='2' line-fg-color='#5dbecd' :size="18" />
        <i v-else :class="['sherpa-icon', 'icon-' + task.taskId]"></i>
      </transition>
      <span>{{ task.label }}</span>
    </button>
  </div>
</template>

<script>
import SpinnerLoading from 'vue-simple-spinner'
import transport from 'vue-definition-utils/src/utils/transport'

export default {
  name: 'definition-task-link',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'repeatableItemIndex',
    'calledTaskIndex'
  ],
  data () {
    return {
      taskLoading: false
    }
  },
  components: {
    SpinnerLoading
  },
  methods: {
    callTask () {
      if (this.task.menuId && this.task.menuId !== '' && this.isJSON(this.task.menuId)) {
        this.taskLoading = true
        var menuIdObj = JSON.parse(this.task.menuId)
        var linkId = transport.methods.getRequestObjectById(transport.methods.getAliasTypeLinkId([this.definition]), this.object).textValue
        var menuIdAlias = transport.methods.getRequestObjectById(menuIdObj.alias, this.object).domainValue[0].key
        var menuIdValue = menuIdObj.values[menuIdAlias]
        if (menuIdValue) {
          this.$emit('taskLink', { name: menuIdValue, params: { id: linkId }, query: { code: this.repeatableGroupCode } })
        }
      }
    },
    isJSON (str) {
      try {
        return (JSON.parse(str) && !!str)
      } catch (e) {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/task/taskLink.vue